import { PlatformRoute } from "@tracabois/template";
import { CsvImportPage } from "../CsvImportPage";
import { CsvImportPreviewPage } from "../CsvImportPreviewPage";

export const CsvImportRoutes: PlatformRoute[] = [
  {
    path: "/csv/import",
    components: <CsvImportPage />,
  },
  {
    path: "/csv/import/:importId",
    components: <CsvImportPreviewPage />,
  },
];
